/**
 * studentValidateEmailViewModel — ce que « Valider l'email » (`<StudentValidateEmailPage>`) lit dans
 * le store : l'adresse du compte, s'il est validé (`is_verified`, qui ferme l'écran), et si une
 * relecture du compte (`getUser`) est en vol — le bouton « Actualiser » tourne pendant ce temps,
 * comme celui de `ValidateEmailScreen.js`.
 *
 * Patron A (le compte est relu par `getUser`, que le réducteur range dans `currentUser.object`).
 * Mémoïsé sur les trois scalaires : le compte change d'identité à chaque relecture, son adresse et
 * sa validation presque jamais.
 */
import { createSelector } from "reselect"
import { selectAccount } from "../../shared/displayedStudent"

export type StudentValidateEmailViewModel = {
    /** `null` tant que le compte n'est pas là. */
    email: string | null
    /** Le compte est validé : l'écran n'a plus rien à faire. */
    verified: boolean
    /** Une relecture du compte est en vol. */
    checking: boolean
}

// Le store est en JS non typé : on lit les champs qu'on connaît, sans le décrire en entier.
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

const selectEmail = (state: ReduxState): string | null => {
    const email = selectAccount(state)?.email
    return typeof email === "string" && email !== "" ? email : null
}
// Lu comme l'ancien écran (`if (props.user?.is_verified)`) : toute valeur vraie vaut validé.
const selectVerified = (state: ReduxState): boolean => !!selectAccount(state)?.is_verified
const selectChecking = (state: ReduxState): boolean => !!state?.api?.getUser?.request

export const studentValidateEmailViewModel = createSelector(
    [selectEmail, selectVerified, selectChecking],
    (email, verified, checking): StudentValidateEmailViewModel => ({ email, verified, checking })
)
